import { render, staticRenderFns } from "./DistrictView.vue?vue&type=template&id=54add227&"
import script from "./DistrictView.vue?vue&type=script&lang=js&"
export * from "./DistrictView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports